import { render, staticRenderFns } from "./FollowUpDate.vue?vue&type=template&id=bc3a8da6"
import script from "./FollowUpDate.vue?vue&type=script&lang=js"
export * from "./FollowUpDate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports